import React from "react";
import "../CSS/About.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutMe = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleAchievementsClick = () => {
    navigate("/achievements");
  };

  return (
    <div className="about-me-container">
      <h1 className="about-me-heading">{t('about.heading')}</h1>
      <p className="about-me-text">
      <a href="/social">SocialLinks</a><br/>
        {t('about.intro')}
      </p>
      <p className="about-me-text">
        {t('about.overview')}
        <ul>
          <li>
            <strong>{t('about.projects.bhumi.title')}</strong>: {t('about.projects.bhumi.description')}
          </li>
          <li>
            <strong>{t('about.projects.meriAawaz.title')}</strong>: {t('about.projects.meriAawaz.description')}
          </li>
          <li>
            <strong>{t('about.projects.collabCircle.title')}</strong>: {t('about.projects.collabCircle.description')}{''}
            <a href="https://github.com/ramswarooppatel/CollabCircle.git" target="_blank" rel="noopener noreferrer">
              {t('about.projects.collabCircle.linkText')}
            </a>.
          </li>
          <li>
            {t('about.projects.aiMl.description')}
          </li>
        </ul>
      </p>
      <p className="about-me-text">
        {t('about.passion')}
      </p>
      <p className="about-me-text">
        {t('about.contribution')}
      </p>
      
      {/* <button className="about-me-button" onClick={handleAchievementsClick}>
        {t('about.achievements.heading')}
        </button> */}
    </div>
  );
};

export default AboutMe;